"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const useControlEvents_1 = __importDefault(require("../../../hooks/useControlEvents"));
const useAppAtomStyleFromControlStyle_1 = __importDefault(require("../../../hooks/useAppAtomStyleFromControlStyle"));
const TextAreaRenderer = ({ textControl, }) => {
    var _a;
    const { Render, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(textControl);
    (0, useOnLoad_1.default)(textControl, events);
    let Container = Render.View;
    const getAtomStyle = (0, useAppAtomStyleFromControlStyle_1.default)();
    if (events.onPress) {
        Container = Render.TouchableOpacity;
    }
    const rawContainerStyle = getAtomStyle((_a = textControl.style) !== null && _a !== void 0 ? _a : {});
    const isWeb = processor.root.platformOS === 'web';
    const containerStyle = isWeb ? Object.assign(Object.assign({}, rawContainerStyle), { borderTopWidth: rawContainerStyle.borderTopWidth || 0, borderRightWidth: rawContainerStyle.borderRightWidth || 0, borderBottomWidth: rawContainerStyle.borderBottomWidth || 0, borderLeftWidth: rawContainerStyle.borderLeftWidth || 0 }) : rawContainerStyle;
    const text = (0, react_1.useMemo)(() => {
        if (typeof textControl.text === 'object') {
            return JSON.stringify(textControl.text);
        }
        return textControl.text;
    }, [textControl.text]);
    return (react_1.default.createElement(Container, { style: containerStyle, onPress: events.onPress },
        react_1.default.createElement(Render.Text, { style: {
                color: containerStyle.color,
                fontSize: containerStyle.fontSize,
                textAlign: containerStyle.textAlign || 'left',
                fontWeight: containerStyle.fontWeight || 'normal',
                fontStyle: containerStyle.fontStyle || 'normal',
                textDecorationLine: containerStyle.textDecoration || 'none',
            } }, text)));
};
TextAreaRenderer.displayName = 'TextAreaRenderer';
exports.default = TextAreaRenderer;
